import React, { useEffect, useState } from 'react';
import { Menu, X, Disc } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'The Silence',
    href: '#problems'
  }, {
    name: 'The Rhythm',
    href: '#solutions'
  }, {
    name: 'Tracklist',
    href: '#features'
  }, {
    name: 'Backstage',
    href: '#pricing'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-background/90 backdrop-blur-md border-b border-white/10 py-4' : 'bg-transparent py-6'}`} data-id="element-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        <div className="flex items-center justify-between" data-id="element-102">
          {/* Logo */}
          <div className="flex items-center gap-2" data-id="element-103">
            <div className="relative" data-id="element-104">
              <Disc className={`w-8 h-8 text-neon-cyan ${isScrolled ? 'animate-spin-slow' : ''}`} data-id="element-105" />
              <div className="absolute inset-0 bg-neon-cyan blur-md opacity-40" data-id="element-106" />
            </div>
            <span className="text-2xl font-display font-black tracking-tighter text-white" data-id="element-107">
              LUTE<span className="text-neon-cyan" data-id="element-108">GAMES</span>
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-109">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-300 hover:text-neon-cyan transition-colors uppercase tracking-widest" data-id="element-110">
                {link.name}
              </a>)}
            <Button variant="primary" size="sm" glow data-id="element-111">
              Start Playing
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-112">
            {isMobileMenuOpen ? <X data-id="element-113" /> : <Menu data-id="element-114" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-surface border-b border-white/10 p-4 flex flex-col gap-4 shadow-2xl" data-id="element-115">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-medium text-gray-300 hover:text-neon-cyan transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-116">
              {link.name}
            </a>)}
          <Button variant="primary" className="w-full" data-id="element-117">
            Start Playing
          </Button>
        </div>}
    </nav>;
}